import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';

export const DateField = (props) => (
	<label
		className={`date-picker wrapping-label ${props.className}`}
		htmlFor={props.name} >
		<span className="label">
			{props.label}
			{props.required ? ('*') : (false)}
		</span>
		<DayPickerInput
			inputProps={{
				id: props.name,
				name: props.name
			}}
			placeholder={
				props.value ? 
					(moment(props.value).format('L')) : (
					"mm/dd/yyyy")}
			formatDate={props.formatDate}
			parseDate={props.parseDate}
			onDayChange={(date) => {props.handleDateInput(date, props.name)}} />
		<img className="calendar-icon" src="images/icons/calendar.svg" aria-hidden="true" alt="" />
		<span className="form-error">
    		<p>{props.errMessage}</p>
    	</span>
	</label>
);


// WEBPACK FOOTER //
// ./src/components/DateField/DateField.js